const FilterListIcon = props => (
	<svg viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M6.25 11.75H8.75V10.5H6.25V11.75ZM1.875 4.25V5.5H13.125V4.25H1.875ZM3.75 8.625H11.25V7.375H3.75V8.625Z"
			fill="currentColor"
		/>
	</svg>
);

export default FilterListIcon;
